"use client";

// Filterkopf der Zuordnungen — aus dem Listen-Baukasten, wie jede Liste.
import { Repeat } from "lucide-react";
import {
  Auswahlfeld,
  Filterkopf,
  Filterzurueck,
  Fuge,
  Luecke,
  Schiene,
  Suchfeld,
  useAnsicht,
  Zaehlknopf,
  Zaehlschiene,
  type Auswahl,
} from "@/components/liste";
import { PRUEFUNGEN, STAENDE, Z_PARAMS, zuordnungFilter, type ZuordnungAnsicht } from "@/lib/beitraege/ansicht";

export function ZuordnungenFilterkopf({
  ansicht,
  arten,
  pruefZaehler,
  zahlartZaehler,
  standZaehler,
}: {
  ansicht: ZuordnungAnsicht;
  arten: Auswahl[];
  pruefZaehler: Record<string, number>;
  zahlartZaehler: Record<string, number>;
  standZaehler: Record<string, number>;
}) {
  const { setzen, isPending } = useAnsicht();
  return (
    <Filterkopf
      isPending={isPending}
      oben={
        <>
          <Suchfeld wert={ansicht.q} platzhalter="Name, Nummer, Familie, Mandat …" beschriftung="Zuordnungen durchsuchen" />
          <Schiene>
            <Auswahlfeld
              icon={Repeat}
              titel="Beitragsart"
              label="Beitragsart"
              eintraege={arten}
              gewaehlt={ansicht.beitrag}
              onWaehlen={(id) => setzen({ beitrag: id })}
              suchtext="Beitragsart suchen …"
              alleLabel="Alle Beitragsarten"
              leerText="Keine Beitragsart gefunden"
            />
          </Schiene>
          <Schiene>
            {[
              { k: "SEPA", l: "Lastschrift" },
              { k: "TRANSFER", l: "Überweisung" },
            ].map((z) => (
              <Zaehlknopf
                key={z.k}
                label={z.l}
                anzahl={zahlartZaehler[z.k] ?? 0}
                aktiv={ansicht.zahlart === z.k}
                onClick={() => setzen({ zahlart: ansicht.zahlart === z.k ? null : z.k })}
              />
            ))}
          </Schiene>
          <Luecke />
          <Schiene>
            {STAENDE.map((s) => (
              <Zaehlknopf
                key={s.schluessel || "heute"}
                label={s.label}
                anzahl={standZaehler[s.schluessel] ?? 0}
                aktiv={ansicht.stand === s.schluessel}
                onClick={() => setzen({ stand: s.schluessel || null })}
              />
            ))}
          </Schiene>
        </>
      }
      unten={
        <>
          <Zaehlschiene titel="Prüfen">
            {PRUEFUNGEN.map((p, i) => (
              <span key={p.schluessel} className="contents">
                {i === 1 && <Fuge />}
                {i === 4 && <Fuge />}
                <Zaehlknopf
                  label={p.label}
                  anzahl={pruefZaehler[p.schluessel] ?? 0}
                  aktiv={ansicht.pruefung === p.schluessel}
                  ton={i < 4 ? "gefahr" : "normal"}
                  titel={p.hinweis}
                  onClick={() => setzen({ pruefung: ansicht.pruefung === p.schluessel ? null : p.schluessel })}
                />
              </span>
            ))}
          </Zaehlschiene>
          <Filterzurueck anzahl={zuordnungFilter(ansicht)} params={Z_PARAMS} />
        </>
      }
    />
  );
}
